import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleDown = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M11.134 16.5a1 1 0 0 0 1.732 0l3.464-6a1 1 0 0 0-.866-1.5H8.536a1 1 0 0 0-.866 1.5z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleDown)
export default ForwardRef
